import axios from "axios";
import nprogress from 'nprogress'
import { get_token, delete_token } from "@/utils/token";
import router from '@/router/index'
import store from '@/store/index'
import { Message } from "element-ui";
//创建实例
const request = axios.create({
  baseURL: process.env.VUE_APP_API1,
  timeout: 600000, //超时时间 1分钟
  headers: {

  },
});

//请求拦截器
request.interceptors.request.use((config) => {
  const token = 'Admin-Token'
  config.headers[token] = get_token()
  nprogress.start()
  return config;
});

//响应拦截器
request.interceptors.response.use((response) => {
  console.log('response000',response);
  if (response.data.code === 200) {
    nprogress.done()
    return response.data.data;
  }
  if (response.data.code === 28004) {
    // token 过期
    nprogress.done()
    store.commit('delete_user')
    router.push({ path: '/login', params: { timeOut: 0 } })
    return Promise.reject(response.data);
  }
  if (response.data.code === 28005) {
    //账号被禁用
    Message.error('Your account has been disabled, please contact your agent if you have any questions!')
    nprogress.done()
    return Promise.reject(response.data);
  }
  nprogress.done()
  return Promise.reject(response.data);
},
  (error) => {
    nprogress.done()
    if(error.response.data.status===500)  Message.error('Server error Please check and try again')
    if(error.response.data.status===404)  Message.error('Address error Please check and try again')
    return Promise.reject(error);
  }
);
export default request;

